// src/components/CaseStudies.js
import React from 'react';

const CaseStudies = () => {
  const caseStudies = [
    {
      title: "Boosting E-commerce Sales",
      description: "Learn how our platform helped an online retailer increase their sales by 150% in just three months.",
      image: "https://pub-5d8aff725acf4e3f9f11593eeae3c846.r2.dev/production/28733/28733-img-6061-1658417306.jpg",
    },
    {
      title: "Streamlining Operations",
      description: "Discover how a logistics company reduced operational costs by 30% using our solutions.",
      image: "https://raindance.org/wp-content/uploads/2023/02/Issues-on-Set-Featured.jpg",
    },
    {
      title: "Enhancing Customer Engagement",
      description: "See how our tools improved customer engagement for a leading service provider.",
      image: "https://www.goto.com/-/media/blog/posts/2024/products/goto-blog-customer-engagement-strategy-670451px.jpg",
    },
  ];

  return (
    <div className="p-6 max-w-6xl mx-auto bg-gray-900 text-white">
      <h1 className="text-4xl font-extrabold mb-8 text-center">Case Studies</h1>
      <p className="text-lg mb-12 text-center">
        Discover how our solutions have transformed businesses. Explore detailed case studies showcasing real-world examples and success stories.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {caseStudies.map((caseStudy, index) => (
          <div key={index} className="bg-gray-800 rounded-lg shadow-lg overflow-hidden">
            <img src={caseStudy.image} alt={caseStudy.title} className="w-full h-48 object-cover" />
            <div className="p-6">
              <h2 className="text-2xl font-bold mb-2">{caseStudy.title}</h2>
              <p className="text-gray-300">{caseStudy.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseStudies;
